import React from "react";
import "./styles.scss";
import { Image } from "react-bootstrap";

export default function SocialButton(props) {
  const { isMobile } = props;
  const iconSize = isMobile ? 60 : 80;
  return (
    <div className="button-container">
      <a
        href="https://www.facebook.com/SindhiDryFruits/"
        target="_blank"
        rel="noopener noreferrer"
        className="glass-btn blue-btn"
      >
        <Image
          width={iconSize}
          src={require("../../assets/icons/fb.png")}
          className="facebook-icon"
        />
      </a>

      <a
        href="https://instagram.com/sindhidryfruits?igshid=56qas9zerwfx"
        className="glass-btn red-btn"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Image
          width={iconSize}
          src={require("../../assets/icons/insta.png")}
          className="facebook-icon"
        />
      </a>
      <a
        href="https://g.page/Sindhidryfruitsdelhi?gm"
        className="glass-btn red-btn"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Image
          width={iconSize}
          src={require("../../assets/icons/google.png")}
          className="facebook-icon"
        />
      </a>
    </div>
  );
}
